var icon = require('vue-svgicon');
// console.log('');
icon.register({
  'send': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: `<path pid="0" d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"/>`
  }
});



// WEBPACK FOOTER //
// ./src/icons/send.js